import { CampaignsIcon, DonationsIcon, PeopleIcon, VolunteersIcon } from '@/assets/icons'
import React from 'react'

export const ImpactHighlights = () => {

  const Highlights = [
    {
      icon: <DonationsIcon />,
      number: "932",
      subtitle: "Total Donations",
    },
    {
      icon: <CampaignsIcon />,
      number: "70k",
      subtitle: "Campaigns Closed",
    },
    {
      icon: <PeopleIcon />,
      number: "10M",
      subtitle: "Happy People",
    },
    {
      icon: <VolunteersIcon />,
      number: "201",
      subtitle: "Our Volunteers",
    },
  ]

  return (
    <div className='my-16 lg:my-24 bg-[#3C51A00D] flex justify-center  flex-col md:flex-row gap-10 md:gap-12 lg:gap-40 py-16 lg:py-24'>
      {
        Highlights.map((n, i) => {
          return (
            <div key={i} className='text-center flex flex-col items-center gap-2'>
              <span>                {n.icon}
              </span>
              <h2 className='font-bold pt-2'>{n.number}</h2>
              <span className='text-sm text-dark-gray'>{n.subtitle}</span>
            </div>
          )
        })
      }
    </div>
  )
}
